import { IgBasePrimitives } from "@intelligems/ig-design-tokens";

export const GET_STARTED_GRADIENT = `linear-gradient(90deg, ${IgBasePrimitives.A100} 0%, ${IgBasePrimitives[800]} 20%, ${IgBasePrimitives[700]} 40%, ${IgBasePrimitives[700]} 60%, ${IgBasePrimitives[500]} 80%, ${IgBasePrimitives[400]} 100%)`;
